import Axios from 'axios';
import { useState, useEffect } from 'react';
import { API_URL } from '../lib/const';


function usePreference(preference) {
  const [data, setData] = useState({value: false});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await Axios.get(`${API_URL}/core/preferences/${preference}`)

        setData(response.data)
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [preference]);

  return { data, error, loading };
}

export default usePreference;
